import * as React from "react";
import CountUp from "react-countup";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";

interface OdometerData {
  /** TYTUŁ ODOMETERA */
  odometerTitle: string

  /** LICZBA OD KTÓREJ BĘDZIE SIĘ ZACZYNAĆ ODLICZANIE ODOMETERA */
  odometerStart: number

  /** LICZBA NA KTÓREJ BĘDZIE SIĘ KOŃCZYĆ ODLICZANIE ODOMETERA */
  odometerEnd: number

  /** TEKST ZA LICZBĄ ODOMETERA => NP. JEDNOSTKA */
  odometerSuffix?: string

  /** CZAS PRACY ODOMETERA => ILE MA TRWAĆ ODLICZANIE W SEKUNDACH */
  odometerDuration: number
}

interface FullWidthImageOnLeftBlockProps {
  /** PIERWSZY KAWAŁEK TYTUŁU => CZARNY */
  blockTitlePart1Black: string

  /** DRUGI KAWAŁEK TYTUŁU => NIEBIESKI */
  blockTitlePart2Blue: string

  /** TRZECI KAWAŁEK TUTUŁU => CZARNY */
  blockTitlePart3Black: string

  /** TUTUŁ W ODLICZNIKU */
  blockSubtitle: string | string[]

  /** TEXTY W ODLICZNIKU => PODZIELONE NA AKAPITY */
  numberBoxParagraphs: string[]

  /** ODLICZNIKI => MUSZĄ BYĆ DOKŁADNIE 4 */
  odometers: OdometerData[]

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType
}

interface FullWidthImageOnLeftBlockState {
  odometersReady: boolean
}

class FullWidthImageOnLeftBlock extends React.Component<FullWidthImageOnLeftBlockProps,FullWidthImageOnLeftBlockState> {

  constructor(props: FullWidthImageOnLeftBlockProps) {
    super(props);
    this.state = {
      odometersReady: false
    };
    this.onComponentView = this.onComponentView.bind(this);
  }

  onComponentView() {
    // ODLICZNIKI
    this.setState({odometersReady: true});

    // GOOGLE EVENT
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  render() {
    const {blockTitlePart1Black,blockTitlePart2Blue,blockTitlePart3Black,blockSubtitle,numberBoxParagraphs,odometers} = this.props;
    const {odometersReady} = this.state;

    // SPRAWDZANIE CZY SUBTITLE JEST LISTĄ
    const blockSubtitleIsArray: boolean = Array.isArray(blockSubtitle);

    // ZWRACANIE DANYCH
    return (
      <div className="goodgrowth-theme-styles" onMouseEnter={this.onComponentView}>
        <section className="numbers">
          <div className="row">
            <div className="col-sm-3 col-md-4 col-lg-6"/>

            <div className="col-sm-9 col-md-8 col-lg-6">
              <h2>{blockTitlePart1Black}<span>{blockTitlePart2Blue}</span>{blockTitlePart3Black}</h2>
              {!blockSubtitleIsArray && <StyledH4>{blockSubtitle}</StyledH4>}
              {blockSubtitleIsArray && (blockSubtitle as string[]).map((blockSubtitlePart: string, i: number) => <StyledH4 key={i}>{blockSubtitlePart}</StyledH4>)}
              <div className="row no-gutter wow fadeInUp" data-wow-duration="600ms" data-wow-delay="600ms">
                <div className="col-sm-8 col-md-8 col-lg-9">
                  <div className="numbersbox">
                    {numberBoxParagraphs.map((paragraph: string, index: number) => <p key={index}>{paragraph}</p>)}
                  </div>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-3">
                  <div className="numbersbox-small">
                    {odometers.map((odometer: OdometerData, index: number) =>
                      <StyledOdometerNumber className="number" key={index}>
                        <div className="odometer">
                          {odometersReady ?
                            <CountUp start={odometer.odometerStart} end={odometer.odometerEnd} duration={odometer.odometerDuration} />
                            :
                            <span>{odometer.odometerEnd}</span>
                          }
                          <span className="odometer-suffix">{odometer.odometerSuffix}</span>
                        </div>
                        <StyledAchievementsName className="numbername">{odometer.odometerTitle}</StyledAchievementsName>
                      </StyledOdometerNumber>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }

}

/** styles */

const StyledH4 = styled.h4`
  color: rgb(128, 128, 128) !important;
  margin-top: -25px !important;
  margin-bottom: 20px !important;
  font-weight: 300 !important;
`;

const StyledOdometerNumber = styled.div`
  line-height: 26px !important;
  span.odometer-suffix {
    font-size: 16px;
    margin-left: 4px;
  }
`;

const StyledAchievementsName = styled.div`
  line-height: 15px !important;
`;

export default FullWidthImageOnLeftBlock


// WEBPACK FOOTER //
// ./src/layouts/full-width-image-on-left-block/full-width-image-on-left-block.tsx